import Vue from "vue";
import Vant, { Locale } from "vant";
import "vant/lib/index.css";
import enUS from "vant/es/locale/lang/en-US";

Vue.use(Vant);
//  add other langs in future
Locale.use("en-US", enUS);
